import BunkeyAPI from '../api/BunkeyAPI'

/**
 * Fetches AWS authentication credentials from the backend.
 * Uses the BunkeyAPI which already handles authentication headers and error handling.
 * Endpoint: GET /user/aws-auth
 * @returns {Promise<Object>} - AWS credentials: { region, accessKeyId, secretAccessKey }
 */
export const fetchAwsAuthCredentials = async () => {
  try {
    const response = await BunkeyAPI({
      url: '/auth/aws-auth',
      method: 'get'
    })
    return response.data; // Expected: { region, accessKeyId, secretAccessKey }
  } catch (error) {
    console.error('Error fetching AWS auth credentials:', error.response || error.message);
    throw error;
  }
};
